// One request at a time; hidden/offline tabs do not poll.
export function createVisiblePoller(refresh, options = {}) {
  const doc = options.document ?? document;
  const win = options.window ?? window;
  const nav = options.navigator ?? navigator;
  const every = options.setInterval ?? setInterval;
  const clear = options.clearInterval ?? clearInterval;
  const now = options.now ?? Date.now;
  let stopped = false, running = false, lastStarted = -Infinity;
  const run = async () => {
    if (stopped || running || doc.hidden || nav.onLine === false || now() - lastStarted < 2000) return;
    running = true;
    lastStarted = now();
    try { await refresh(); } catch { /* Preserve the last successful list; retry next time. */ }
    finally { running = false; }
  };
  const timer = every(run, options.interval ?? 30000);
  doc.addEventListener('visibilitychange', run);
  win.addEventListener('focus', run);
  win.addEventListener('online', run);
  return () => {
    stopped = true;
    clear(timer);
    doc.removeEventListener('visibilitychange', run);
    win.removeEventListener('focus', run);
    win.removeEventListener('online', run);
  };
}
